import config from 'site-react/config';

const mobileLinks = [
  {
    links: [
      {
        label: 'Signup',
        url: '/signup',
      },
      {
        label: 'Login',
        url: '/login',
      },
    ],
    loggedIn: false,
    title: 'Welcome',
  },
  {
    links: [
      {
        label: 'Surveys',
        url: '/survey-dashboard',
      },
      {
        label: 'Favourites',
        url: '/favourites',
      },
      {
        label: 'Viewings',
        url: '/viewings?utm_source=dashboard&utm_medium=mobile',
      },
      {
        label: 'Profile',
        url: '/profile',
      },
      {
        label: 'Change Password',
        url: '/change-password',
      },
      {
        label: 'Inbox',
        url: config.HUBBLE_INBOX_URL,
      },
      {
        label: 'Log Out',
        clickAction: 'logout',
        url: '/logout',
      },
    ],
    loggedIn: true,
    title: 'Dashboard',
  },
  {
    analytics: {
      event: 'Search Clicked',
    },
    links: [
      {
        label: 'Search',
        url: '/office-space-london',
      },
    ],
    title: 'Search',
  },
  {
    analytics: {
      event: 'List Your Space Clicked',
    },
    links: [
      {
        label: 'List Your Space',
        url: '/host',
      },
    ],
    title: 'List Your Space',
  },
  {
    analytics: {
      event: 'Locations Clicked',
    },
    links: [
      {
        icon: 'keyboard_arrow_right',
        clickAction: 'setActivePanel',
        label: 'Locations',
        panelName: 'locations',
        url: '#',
      },
    ],
    title: 'Locations',
  },
  {
    analytics: {
      event: 'Guides Clicked',
    },
    links: [
      {
        clickAction: 'setActivePanel',
        icon: 'keyboard_arrow_right',
        label: 'Guides',
        panelName: 'guides',
        url: '#',
      },
    ],
    title: 'Guides',
  },
  {
    analytics: {
      data: (link) => ({
        name: link.label && link.label.replace(' ', '-').toLowerCase(),
      }),
      event: 'Hubble Link Clicked',
    },
    links: [
      {
        label: 'About us',
        url: '/about',
      },
      {
        label: 'Blog',
        url: '/blog',
      },
      {
        label: 'Contact',
        url: '/contact',
      },
    ],
    loggedIn: true,
    title: 'Help',
  },
  {
    analytics: {
      data: (link) => ({
        name: link.label && link.label.replace(/\s/g, '-').toLowerCase(),
      }),
      event: 'Hubble Link Clicked',
    },
    links: [
      {
        label: 'About us',
        url: '/about',
      },
      {
        label: 'Blog',
        url: '/blog',
      },
      {
        label: 'Contact',
        url: '/contact',
      },
    ],
    loggedIn: false,
    title: 'Help',
  },
];

export default mobileLinks;
